import { useEffect, useState } from 'react';

import { Auth } from '@aws-amplify/auth';
import { Hub } from '@aws-amplify/core';

export const useUser = () => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const updateUser = async () => {
      try {
        const authenticatedUser = await Auth.currentAuthenticatedUser();
        setUser(authenticatedUser);
      } catch {
        setUser(null);
      } finally {
        setIsLoading(false);
      }
    };
    const unsubscribe = Hub.listen('auth', updateUser);
    updateUser().catch(console.error);
    return () => unsubscribe();
  }, []);

  return { user, isLoading };
};
